module.exports = __webpack_public_path__ + "img/mastercard-square.88488c94.svg";